import React from 'react';
import MediaManager from './MediaManager';

/**
 * Post-migration profile library: same engine as {@link MediaManager} with a tab scope.
 * @param {'media'|'community'|'roomEq'|'tours'|'savedVenues'|'reports'|'all'} libraryTab — passed as `profileLibraryTab` (`all` = full tree).
 */
export default function ProfileTabbedMediaManager({ libraryTab = 'all', readOnly, ...rest }) {
  return (
    <MediaManager
      {...rest}
      profileLibraryTab={libraryTab}
      readOnly={readOnly}
    />
  );
}
